import React from 'react'
import { Country, EntityType } from 'api'
import { Field } from 'view/components/inputs'
import { Selectbox, SelectboxProps } from 'view/components/options'
import { useSelector } from 'react-redux'
import { createAllEntitiesSortedSelector } from 'selectors/entitySelectors'

type CountrySelectboxProps = Omit<SelectboxProps<string, string>, 'optionKeys'>

const countriesSortedSelector = createAllEntitiesSortedSelector(EntityType.COUNTRY)

export const CountrySelectbox = React.forwardRef((props: CountrySelectboxProps, ref: React.Ref<Selectbox>) => {
  const countries = useSelector(countriesSortedSelector)
  const countryCodes = countries.map(country => country.isoTwoDigitAlphaCode)

  const getCountryNameAndCode = (countries: Country[]) => (countryCode: string) => {
    const country = countries.find(country => country.isoTwoDigitAlphaCode === countryCode)
    return country ? `${country.countryName} - ${country.isoTwoDigitAlphaCode}` : countryCode
  }

  return <Selectbox ref={ref} optionKeys={countryCodes} getOptionText={getCountryNameAndCode(countries)} {...props} />
})

export const CountrySelectboxField = Field(CountrySelectbox)
